'use client';
import React from 'react';
import FooterlLinkLists from './FooterlLinkLists';
import { platformDomainSelector } from '@/app/services/ArticleService';

const platform = process.env.NEXT_PUBLIC_PLATFORM;
const baseDomain = platformDomainSelector(platform);

const LegalList = [
  {
    title: 'Privacy Policy',
    link: `${baseDomain}`,
  },
  {
    title: 'Refund & Cancellation Policy',
    link: `${baseDomain}`,
  },
  {
    title: 'Terms & Conditions',
    link: `${baseDomain}`,
  },
  {
    title: 'Disclaimer',
    link: `${baseDomain}`,
  },
];

const FooterLegal = () => {
  const filteredLegalList =
    platform === 'paBlog'
      ? LegalList.filter((item) => item.title !== 'Disclaimer')
      : LegalList;

  return (
    <section className='max-sm:w-[60%]'>
      <h2 className='mb-[25px]  text-[16px] font-medium text-[#fff]'>Legal</h2>
      <FooterlLinkLists data={filteredLegalList} targetBlank />
    </section>
  );
};

export default FooterLegal;
